/*
  500 - Internal Server Error
  See Error404.tsx for shared ErrorPage component and styling notes.
*/
import { ErrorPage } from './Error404'

export default function Error500() {
  return <ErrorPage code="500" title="Something went wrong" body="The server encountered an error and could not complete your request. Please try again in a few moments. If the problem persists, please contact us." />
}
